"use strict";

exports.__esModule = true;
exports.PluginButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _Auth = require("../../Auth");
var _PluginsList = require("../PluginsList");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PluginButton = exports.PluginButton = function PluginButton(props) {
  var config = props.config,
    onClicked = props.onClicked,
    context = props.context;
  var plugin = _PluginsList.PluginsList[config.type];
  if (plugin) {
    var linkStatus = plugin.getLinkStatus(context);
    var isEnabled = config.isLinking === false && plugin.isEnabled(context);
    return /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
      permission: config.permission
    }, plugin.render(isEnabled, linkStatus, config, onClicked));
  }
  return null;
};